/**
 * WalletConnect v2 세션과 브라우저 주입 지갑(window.ethereum) 중
 * Redux `connectionMode` 에 맞는 EIP-1193 프로바이더를 고릅니다.
 */
let walletConnectProvider = null;

export function setWalletConnectSession(provider) {
  walletConnectProvider = provider;
}

export function getWalletConnectSession() {
  return walletConnectProvider;
}

export async function clearWalletConnectSession() {
  const p = walletConnectProvider;
  walletConnectProvider = null;
  if (p && typeof p.disconnect === 'function') {
    try {
      await p.disconnect();
    } catch {
      /* ignore */
    }
  }
}

/**
 * @param {'injected' | 'walletconnect' | null | undefined} connectionMode
 * @returns {import('ethers').providers.ExternalProvider | null}
 */
export function getActiveEip1193Provider(connectionMode) {
  if (connectionMode === 'walletconnect' && walletConnectProvider) {
    return walletConnectProvider;
  }
  if (typeof window !== 'undefined' && window.ethereum) {
    return window.ethereum;
  }
  return null;
}
